import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedTool, setSelectedTool } from '@/store/slices/ToolsSlice'
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { nonAudioTools } from '@/shared/config/constants';
import { useGetToolsQuery } from '@/api/rtk/toolsApi';

const EMPTY_ARRAY = [];

export const useCurrentTool = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedTool = useSelector(selectSelectedTool);
  const userId = localStorage.getItem('user_id') || '';

  const integrationRoute = location.pathname.includes('/integration');

  const { data } = useGetToolsQuery(undefined, { skip: !userId || integrationRoute });
  const allToolsData = data?.tools || EMPTY_ARRAY;

  const nonAudioTool = nonAudioTools.includes(selectedTool);
  
  const selectedToolData = useMemo(
    () => allToolsData.find((tool) => tool.name === selectedTool) || null,
    [allToolsData, selectedTool]
  );

  useEffect(() => {
    if (!userId || integrationRoute) return;

    if (!selectedTool) {
      const path = window.location.pathname.split('/')[1];
      const tool = allToolsData.find(tool => tool.name.split(' ')[0].toLowerCase() === path);
      
      if (tool) {
        dispatch(setSelectedTool(tool.name));
      }
    }
  }, [dispatch, allToolsData, selectedTool, userId, integrationRoute]);

  const currentToolFields = selectedToolData?.fields || EMPTY_ARRAY;
  const toolInputs = selectedToolData?.inputs || EMPTY_ARRAY;
  const toolOutputs = selectedToolData?.outputs || EMPTY_ARRAY;

  const generation_name_key = (selectedToolData?.generation_name || '').toLowerCase();
  const generation_name = generation_name_key ? t(`common.${generation_name_key}`) : '';
  const gen_name_plural = generation_name_key ? t(`common.${generation_name_key}s`) : '';
  const toolId = selectedToolData?.id || '';

  const getToolDescription = useCallback((tool_id) => {
    const tool = allToolsData.find(tool => tool.id === tool_id);
    return tool ? `${selectedTool ? '' : tool.name+"'s "}${generation_name}` : '';
  }, [allToolsData, selectedTool, generation_name]);

  // German (and similar) gender: i18next looks up key_<context> then falls back to key.
  const tGeneration = useCallback(
    (key, options) => t(key, { type: generation_name, context: generation_name_key, ...options }),
    [t, generation_name, generation_name_key],
  );

  return { currentToolFields, toolId, generation_name, gen_name_plural, toolInputs, toolOutputs, toolName:selectedTool, nonAudioTool, getToolDescription, tGeneration };
};
